export enum SystemLanguage {
  PL = 'PL',
  EN = 'EN',
  RO = 'RO',
  UK = 'UK',
  DE = 'DE',
}
